// Process html entity - &#123;, &#xAF;, &quot;, ...
import { decodeHTML } from 'entities';
import { isValidEntityCode, fromCodePoint } from '../common/utils.mjs';
var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
export default function entity(state, silent) {
  var pos = state.pos;
  var max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x26
  /* & */
  ) return false;
  if (pos + 1 >= max) return false;
  var ch = state.src.charCodeAt(pos + 1);

  if (ch === 0x23
  /* # */
  ) {
      var match = state.src.slice(pos).match(DIGITAL_RE);

      if (match) {
        if (!silent) {
          var code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
          var token = state.push('text_special', '', 0);
          token.content = isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
          token.markup = match[0];
          token.info = 'entity';
        }

        state.pos += match[0].length;
        return true;
      }
    } else {
    var _match = state.src.slice(pos).match(NAMED_RE);

    if (_match) {
      var decoded = decodeHTML(_match[0]);

      if (decoded !== _match[0]) {
        if (!silent) {
          var _token = state.push('text_special', '', 0);

          _token.content = decoded;
          _token.markup = _match[0];
          _token.info = 'entity';
        }

        state.pos += _match[0].length;
        return true;
      }
    }
  }

  return false;
}